import clsx from "clsx";
import React, { FC } from "react";

interface JunctionSectionProps {
  variant: "top" | "bottom";
}

export const JunctionSection: FC<JunctionSectionProps> = ({ variant }) => (
  <div className="flex justify-end w-full lg:h-full">
    <div
      className={clsx([
        "flex justify-end",
        variant === "top" && "items-end",
        variant === "bottom" && "items-start",
      ])}
    >
      <div
        className={clsx([
          "bg-neutral h-6 w-6",
          variant === "top" && "mask-zip-bottom",
          variant === "bottom" && "mask-zip-top",
        ])}
      />
    </div>
    <div className="hidden lg:block lg:flex-[0_0_25%] bg-neutral" />
  </div>
);
